export default __webpack_public_path__ + "static/media/pasta-icon.a7009b7d.svg";